import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map } from 'rxjs';
import { Brand } from 'src/app/components/company/models/new/brand.model';
import { Category } from 'src/app/components/company/models/new/category';
import { ShotResume } from 'src/app/components/company/models/new/shotResume';
import { Color, Size, Style } from 'src/app/components/company/models/new/style';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { OrderQueries } from 'src/app/shared/types/get-query/order-queries.enum';

@Component({
	selector: 'bt-submit-order-modal',
	standalone: false,
	templateUrl: './submit-order-modal.component.html',
	styleUrl: './submit-order-modal.component.scss'
})
export class SubmitOrderModalComponent {
	readonly #dialogRef = inject(MatDialogRef<SubmitOrderModalComponent>);
	data = inject<any>(MAT_DIALOG_DATA);
	loading: boolean = false;
	styles: Style[] = [];

	constructor(
		private graphQlService: GraphQLService,
		private utilitiesService: UtilitiesService
	) {
		console.log('data', this.data);

		this.loading = true;
		this.graphQlService
			.getData(OrderQueries.GET_SELECTED_SIZES, { orderId: this.data.order?.id })
			.pipe(
				map((res: any) => {
					return res?.data?.orderSelectedSizes?.map(
						(style: any) =>
							new Style({
								modelId: style.modelId,
								brand: new Brand({ name: style.brand.label, id: style.brand.id }),
								category: new Category({ name: style.category.label, id: style.category.id }),
								colors: style.colors.map(
									(c: any) =>
										new Color({
											id: c.id,
											name: c.label,
											size: new Size({
												id: c.sizes[0]?.id,
												name: c.sizes[0]?.label,
												ean: c.sizes[0]?.ean
											})
										})
								)
							})
					);
				})
			)
			.subscribe({
				next: (data: Style[]) => {
					this.styles = data;
					this.loading = false;
				},
				error: (err) => {
					this.utilitiesService.showSnackbar('Error during fetching order resume', SnackbarType.Error);
					console.error(err);
					this.loading = false;
				}
			});
	}

	close() {
		this.#dialogRef.close();
	}

	confirm() {
		this.#dialogRef.close(true);
	}
}
